import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "tile is-ancestor" }
const _hoisted_3 = { class: "tile is-parent is-vertical" }
const _hoisted_4 = { class: "tile is-child" }
const _hoisted_5 = { class: "card has-table has-mobile-sort-spaced" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("header", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "card-header-title" }, " Registrar usuario para solicitud de transparencia ")
], -1)
const _hoisted_7 = { class: "card-content" }
const _hoisted_8 = {
  key: 0,
  class: "message content is-danger is-light"
}
const _hoisted_9 = { class: "message-body" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", null, "Errores de validación:", -1)

import { reactive, ref, Ref, readonly, onMounted } from "vue";
import { UserCreateEvent } from "@/components/user/Form.vue";
import UserForm from "@/components/user/CitizenForm.vue";
import { Role } from "@/entities";
import { useMessages } from "@/store/message";
import { authService } from "@/services/auth";
import useFailureHandler from "@/components/useFailureHandler";
import FailedValidation from "@/error/api/failed-validation";
import FailuresList from "@/components/admin/FailuresList.vue";
import route from "@/router";
import { useGrecaptchaV2, useGrecaptchaV3 } from "@/composables/use-grecaptcha";
/**
 * Reactive Data
 */

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const msg = useMessages();
const failures = ref(new Map());
const onFailure = useFailureHandler(failures);

const data = reactive({
  currentRoles: [] as Role[],
  loadingButton: false,
});

const reCaptcha: Ref<HTMLElement> = ref(null as unknown as HTMLDivElement);
const v2SiteKey = ref("");
onMounted(async () => {
  v2SiteKey.value = await authService.getReCaptchaV2SiteKey();
});
const requestType = readonly(ref("signup"));
const recaptcha = reactive({
  reCaptchaV2SiteKey: null as null | string,
  reCaptcheType: "v3" as "v2" | "v3",
  reCaptchaV2Token: "",
});

const V2 = useGrecaptchaV2(reCaptcha, v2SiteKey);
const V3 = useGrecaptchaV3(requestType);

const onUserRegister = async (user: UserCreateEvent) => {
  console.log(user);
  data.loadingButton = !data.loadingButton;
  try {
    let token_grecaptcha =
      recaptcha.reCaptcheType == "v3"
        ? await V3.validateV3recaptcha()
        : recaptcha.reCaptchaV2Token;

    user.token_grecaptcha = token_grecaptcha;
    user.recaptcha_type = recaptcha.reCaptcheType;
    await authService.registerUser(user);

    route.push({ name: "email-verification-message" });
  } catch (e) {
    data.loadingButton = !data.loadingButton;
    failures.value.clear();

    if (e instanceof FailedValidation) {
      const failure = new Map(Object.entries(e.failures));
      if (failure.has("recaptcha") && recaptcha.reCaptcheType == "v3") {
        recaptcha.reCaptcheType = "v2";
        msg.addWarning("Complete el captcha.");
        V2.renderV2Recaptcha().then(
          (token: string) => (recaptcha.reCaptchaV2Token = token)
        );
      }

      msg.addError("No se pudo crear el usuario. Hubo errores de validación");
      for (const [key, value] of Object.entries(e.failures)) {
        failures.value.set(key, value);
      }
    } else {
      msg.addError("No se pudo crear al usuario.");
    }
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              (failures.value.size)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createVNode(FailuresList, { failures: failures.value }, null, 8, ["failures"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(UserForm, {
                onUserCreate: onUserRegister,
                onFailure: _unref(onFailure),
                "loading-button": _unref(data).loadingButton
              }, null, 8, ["onFailure", "loading-button"]),
              _createElementVNode("div", {
                ref_key: "reCaptcha",
                ref: reCaptcha,
                class: "field mt-3"
              }, null, 512)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})